import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";

type DateTimePickerProps = {
  fullWidth?: boolean;
  disablePast?: boolean;
  size?: "medium" | "small";
  label: string;
  value?: Date | string;
  error?: boolean;
  helperText?: string;
  onChange: (value: string | Date, keyboardInputValue?: string) => void;
};

export function DateTimePicker({
  fullWidth,
  disablePast,
  label,
  value,
  size,
  error,
  helperText,
  onChange,
}: DateTimePickerProps) {
  return (
    <MuiDateTimePicker
      disablePast={disablePast ? disablePast : false}
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth={fullWidth}
          size={size}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
